import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";
import {
  BillingApiCurrencyListRequest,
  PageModel
} from "../../../proto/generated/api_entities_pb";
import {InitialPage} from "../../constans/pagination/pagination";
import {PageModelLimits} from "../../constans/pagination/pageModelLimits";
import {API} from "../../../API/API";
import {ICurrency} from "../../../store/reducers/fleetReducer/fleetReducerTypes";
import {store} from "../../../store/store";

export async function fetchCurrencies(search?: string): Promise<DebounceSelectOptionProps[]> {
  // Получаем валюты из store
  const state = store.getState();
  const currencies = state.currency.currencies;

  // Если валюты уже загружены в store, используем их
  if (currencies && currencies.length > 0) {
    const searchLower = (search ?? "").toLowerCase();
    return currencies
      .filter(c => {
        // Фильтруем по поисковому запросу
        if (searchLower && !c.label.toLowerCase().includes(searchLower)) {
          return false;
        }
        return true;
      });
  }

  // Если валюты еще не загружены, делаем запрос (fallback)
  const req = new BillingApiCurrencyListRequest()
    .setPagemodel(
      new PageModel().setPage(InitialPage).setLimit(PageModelLimits.Select)
    );

  search && req.setQuery(search)

  const currencyList = await API.getCurrencyList(req);

  return currencyList.getCurrenciesList().map(currency => {
    return {
      key: currency.getCurrencyid(),
      label: currency.getName(),
      value: currency.getCurrencyid(),
    }
  })
}

export const getInitialCurrencyForSelect = (currency: ICurrency): DebounceSelectOptionProps => {
  return {
    key: currency.id,
    value: currency.id,
    label: currency.name,
  }
}

/**
 * Получает опции валют из стора по массиву ID
 * Используется для отображения выбранных валют в селектах
 */
export function getCurrenciesFromStoreByIds(currencyIds: number[]): DebounceSelectOptionProps[] {
  const state = store.getState();
  const currencies = state.currency?.currencies || [];
  
  return currencyIds
    .map(id => {
      // Ищем валюту по value (может быть number или string)
      const currency = currencies.find(c => {
        // Сравниваем как числа, так как value может быть number или string
        return Number(c.value) === Number(id) || c.value === id;
      });
      return currency;
    })
    .filter(Boolean) as DebounceSelectOptionProps[];
}

export async function getCurrencyById(id: number): Promise<ICurrency | undefined> {
  // Сначала пытаемся получить из стора
  const state = store.getState();
  const currencies = state.currency?.currencies || [];
  const currencyFromStore = currencies.find(c => c.value === id);
  
  if (currencyFromStore) {
    return {
      id: currencyFromStore.value as number,
      name: currencyFromStore.label,
    };
  }

  // Если не найдено в сторе, делаем запрос (fallback)
  const req = new BillingApiCurrencyListRequest()
    .setPagemodel(
      new PageModel().setPage(InitialPage).setLimit(PageModelLimits.Select)
    )

  const currencyList = await API.getCurrencyList(req);

  const currency = currencyList.getCurrenciesList().find(c => c.getCurrencyid() === id);

  if (!currency)
    throw new Error("No currency found by given id: " + id)

  return {
    id: currency.getCurrencyid(),
    name: currency.getName(),
  }
}